/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
import { showFeedback } from './feedback/showFeedback';
import { hideFeedback } from './feedback/hideFeedback';
import d3 from '../globalexports/d3.export';

export const showIonicLoading = (message, hideSpinner) => {
  d3.select('.pre-load-container .load-text').html(message);
  showFeedback(message, hideSpinner);
};
export const hideIonicLoading = () => {
  hideFeedback();
};
